import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Redirect, withRouter, Link } from "react-router-dom";
import LeaseListingTable from "./LeaseListingTable";
import TopHeader from "../layout/TopHeader";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getUserRole } from "../utils/index";
class LeaseListing extends React.Component {
  state = {
    showProspect: false,
    redirect: false,
    brands: [],
    assets: [],
    statusCount: {},
    selectedBrand: this.props.match.params.brand ?? 0,
    selectedAsset: "",
    randomNum: "",
    selectedStatus: Number(this.props.match.params.status),
    state: this.props.match.params.state ?? 0,
  };

  constructor(props) {
    super(props);
  }

  resetCounter = () => {
    this.setState({
      randomNum: Math.random(),
    });
  };

  componentDidMount() { }

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/outflow" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div className="viewLeaseSection">
        <TopHeader />
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/outflow">Outflow</Link>
              </li>
              {!["checker", "user"].includes(getUserRole()) && (
                <>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <Link className="create_lease_landlord" to={"/outflow/create"}>
                    Create
                  </Link>
                </>
              )}
            </ul>
          </div>
        </div>

        <LeaseListingTable
          key={this.state.randomNum}
          ths={this}
        // asset={this.state.selectedAsset}
        // brand={this.state.selectedBrand}
        // status={this.state.selectedStatus}
        // stateId={this.props.match.params.state}
        />
      </div>
    );
  }
}

export default withRouter(LeaseListing);
